import router from '@/router';
import fetchVerifyCode from '@/api/code';
import { fetchExam, fetchExamResults } from '@/api/exam';
import { IRI } from '@/api';

export default {
  fetchUser({ state, commit}) {
    commit('setIsLoading', true);
    return fetchVerifyCode(state.token)
      .then(res => {
        if (res.status === 404 || res.status === 500) {
          commit('reset');
          commit('addError', 'Zły kod');
        }
        else if (res.status === 403) {
          commit('reset');
          commit('addError', 'Kod wygasł');
        }

        return res.json();
      })
      .then(res => {
        if (res.detail) {
          commit('reset');
          commit('addError', res.detail);
          return;
        }

        commit('setResponse', res);
        return res;
      })
      ;
  },
  fetchCourseExam({ state, commit}) {
    commit('setIsLoading', true);
    return fetchExam(state.course.id)
      .then(res => {
        if (res.status === 404 || res.status === 500) {
          commit('reset');
          commit('addError', 'Zły kurs');
        }

        return res.json();
      })
      .then(res => {
        if (res.detail) {
          commit('reset');
          commit('addError', res.detail);
          return;
        }

        commit('setExam', res);
        return res;
      })
      ;
  },
  fetchCourseExamResults({ state, commit}) {
    commit('setIsLoading', true);
    const payload = {
      token: state.token || null,
      course: `${IRI.course}${state.course.id}`,
      answers: state.answers,
    };
    return fetchExamResults(payload)
      .then(res => {
        if (res.status === 404 || res.status === 500) {
          commit('reset');
          commit('addError', 'Zły kurs');
        }

        return res.json();
      })
      .then(res => {
        if (res.detail) {
          commit('reset');
          commit('addError', res.detail);
          return;
        }

        commit('setExamResults', res);
        return res;
      })
      ;
  },
  logout({ commit }) {
    commit('reset');
    router.replace({ name: 'login' });
  },
};
